import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';

import ROUTES from 'routes';
import { useAppDispatch } from 'hooks';
import { clearState } from 'redux/auth/actions';
import Tile from 'components/ui/Tile';
import Button from 'components/ui/Button';
import Typography from 'components/ui/Typography';

import css from './AccountSuspendedError.module.scss';

const AccountSuspendedError: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    return (
        <div className={css.containerSuspended}>
            <Tile>
                <Tile.Header>{t('AccountSuspended.SuspendedAccount')}</Tile.Header>
                <Tile.Item>
                    <Typography color="gray2">
                        <Trans i18nKey="AccountSuspended.SuspendedExplanation">
                            This account has been disabled by the moderation team for a violation of the Terms of
                            Service. If you believe this has occurred in error, you can
                            <Link to={ROUTES.SUPPORT}>contact support</Link>.
                        </Trans>
                    </Typography>
                    <Button
                        withPadding
                        className={css.margin}
                        onClick={() => {
                            dispatch(clearState());
                            navigate(ROUTES.LANDING);
                        }}
                        blocked
                    >
                        {t('Common.ReturnHome')}
                    </Button>
                </Tile.Item>
            </Tile>
        </div>
    );
};

export default AccountSuspendedError;
